import { LogIn } from 'lucide-react';
import { Link } from 'react-router';

import { Button } from '@/components/ui/button';

import {
  AuthTemplate,
  FooterLinks,
} from '@/pages/unauthenticated/auth/components';

export const AlreadyVerified = ({ heading }: { heading: string }) => {
  return (
    <AuthTemplate
      heading={heading}
      subheading="Good news! It looks like this account is already verified."
      footer={<FooterLinks />}
    >
      <Button asChild>
        <Link to="/">
          <LogIn className="w-4 h-4 mr-2" />
          Continue to FlagSync
        </Link>
      </Button>
    </AuthTemplate>
  );
};
